import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../constants/colors';
import IconWrapper from './IconWrapper';
import { fontFamily, fontSize } from '../../../../constants/text';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { CDP_TOUCH_REPORT_INACCURATE_INFO } from '../../../../core/analytics/events';
import { REPORT_INACCURATE_MODAL } from '../../Modals/ReportInaccurateInfoModal';

const Root = styled.div`
  -webkit-font-smoothing: antialiased;
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  color: ${colors.lightText};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const ReportIcon = styled.img`
  height: 10px;
  width: 10px;
  display: inline-block;
  padding-right: 4px;
`;

const NoWrap = styled.span`
  white-space: nowrap;
  font-size: ${fontSize.small};
`;

export default class ReportInaccurateInfo extends PureComponent {
  static propTypes = {
    showModal: PropTypes.func,
    className: PropTypes.string,
    location: PropTypes.object,
  };

  handleReportClick = () => {
    const { id, uclId } = this.props.location;
    this.props.showModal(REPORT_INACCURATE_MODAL);
    analyticsTrackEvent(CDP_TOUCH_REPORT_INACCURATE_INFO, {
      locationId: id,
      uclId,
    });
  };

  render = () => (
    <Root onClick={this.handleReportClick}>
      <IconWrapper className={this.props.className}>
        <ReportIcon src="/images/icons/Icon-Report.svg" alt="Report icon" />
        <NoWrap>Report inaccurate info</NoWrap>
      </IconWrapper>
    </Root>
  );
}
